export const Work = [
    {
        id: 1,
        name: "Social media growth service Website",
        description: "Developed the project from scratch, designed website wireframe, layout, UI, and user flow model.",
        tags: ["react", "styled-components", "material-ui", "django"],

        demo: "https://liketank.com",
        github: "https://github.com/arjang-psh/"
    },
    {
        id: 2,
        name: "Social media growth service Website",
        description: "Developed the project from scratch, designed website wireframe, layout, UI, and user flow model.",
        tags: ["html", "sass", "javaScript", "bootstrap", "django"],

        demo: "https://likeswave.com",
        github: "https://github.com/arjang-psh/"
    },
    {
        id: 3,
        name: "Personal Portfolio Website",
        description: "Build a stunning Portfolio with React Js using Styled-components and framer-motion for awesome Animations.",
        tags: ["react", "styled-components", "framer-motion", "react-router", "react-tsparticles"],

        demo: "http://arjangdev.com/",
        github: "https://github.com/arjang-psh/portfolio-react"

    }, {
        id: 4,
        name: "LinkedIn Clone",
        description: "Create a full stack, LinkedIn clone using React, Firebase, Redux, and Styled Component.",
        tags: ["react", "styled-components", "firebase", "redux", "google-authentication", "netlify"],

        demo: "https://arjang-linkedin-clone.netlify.app/",
        github: "https://github.com/arjang-psh/linkedin-react"
    },
    {
        id: 5,
        name: "Netflix Clone Website",
        description: "A Netflix clone useing React Js and real API functioning to fetch updated data from TMBD api.",
        tags: ["react", "styled-components", "react-router", "netlify"],

        demo: "https://arjang-netflix-clone.netlify.app/",
        github: "https://github.com/arjang-psh/netflix-clone"

    },
    {
        id: 6,
        name: "Goal Tracker Application",
        description: "A simple Goal-Tracker application using React Js",
        tags: ["react", "css-madules"],

        demo: "https://goaltrackerrr.netlify.app/",
        github: "https://github.com/arjang-psh/goal-tracker"


    },

] 
